import * as React from "react";

import NotFound from "components/NotFound";

type NotFoundPageProps = {};

const NotFoundPage: React.FC<NotFoundPageProps> = () => <NotFound />;

export default NotFoundPage;
